/**
 * Mahalaxmi radius based delivery check.
 * Applies only to products that have the local tag
 * (Theme settings > Restaurant location > Product tag, default: Lucknow only).
 * Covers the product page (box, Add to Cart, Buy it now) and the product cards
 * on collection pages (tag, location line, ADD +, quantity +).
 * Timing comes from Theme settings > Restaurant location. Checkout is NOT enforced here.
 */
(function () {
  if (window.__mlpDelivery) return;
  window.__mlpDelivery = true;

  var TZ = 'Asia/Kolkata';
  var CARD_ADD = '[data-cpv2-add-btn], [data-cpv2-qty-plus], .cpv2-card__bulk .quantity__button[name=plus]';
  var timer = null;

  function getCfg() {
    try { return JSON.parse(document.getElementById('mlp-config').textContent); } catch (e) { return null; }
  }

  function readLoc(c) {
    try {
      var l = JSON.parse(localStorage.getItem(c.storageKey) || 'null');
      return l && typeof l.lat === 'number' && typeof l.lng === 'number' ? l : null;
    } catch (e) { return null; }
  }

  function km(c, lat, lng) {
    var r = Math.PI / 180;
    var dLat = (lat - c.storeLat) * r;
    var dLng = (lng - c.storeLng) * r;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(c.storeLat * r) * Math.cos(lat * r) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 2 * 6371 * Math.asin(Math.min(1, Math.sqrt(a)));
  }

  // Hour in India time, whatever the visitor's device timezone is.
  function istHour() {
    try {
      var h = parseInt(new Intl.DateTimeFormat('en-GB', { hour: 'numeric', hour12: false, timeZone: TZ }).format(new Date()), 10);
      return h % 24;
    } catch (e) {
      var d = new Date();
      return new Date(d.getTime() + (d.getTimezoneOffset() + 330) * 60000).getHours();
    }
  }

  function getState() {
    var c = getCfg();
    if (!c || !c.enabled) return null;
    var loc = readLoc(c);
    var radius = Number(c.radiusKm || 10);
    var dist = loc ? km(c, loc.lat, loc.lng) : null;
    var state = !loc ? 'none' : (dist <= radius ? 'ok' : 'out');
    c.startHour = Number(c.startHour || 8);
    c.cutoffHour = Number(c.cutoffHour || 19);
    return { c: c, loc: loc, radius: radius, dist: dist, state: state };
  }

  function deliverySchedule(c) {
    var start = Number(c.startHour);
    var cutoff = Number(c.cutoffHour);
    if (isNaN(start)) start = 8;
    if (isNaN(cutoff)) cutoff = 19;
    start = Math.max(0, Math.min(23, start));
    cutoff = Math.max(0, Math.min(23, cutoff));
    return { start: start, cutoff: cutoff };
  }

  function isClosedHours(c) {
    var s = deliverySchedule(c);
    var h = istHour();
    if (s.start < s.cutoff) return h < s.start || h >= s.cutoff;
    if (s.start > s.cutoff) return h >= s.cutoff && h < s.start;
    return true;
  }

  

  function formatHour(h) {
    h = Number(h);
    var suffix = h >= 12 ? 'PM' : 'AM';
    var hour = h % 12 || 12;
    return hour + ':00 ' + suffix;
  }

  function timing(box, closed) {
    var cutoff = parseInt(box.getAttribute('data-cutoff'), 10);
    if (isNaN(cutoff)) cutoff = 19;
    var start = parseInt(box.getAttribute('data-start-hour'), 10);
    if (isNaN(start)) start = 8;
    var same = box.getAttribute('data-same-day') || 'Same Day Delivery: order before 7 PM to get it today.';
    var next = box.getAttribute('data-next-day') || 'Lucknow delivery for this item is closed for today. Please order tomorrow after {{start_time}}.';
    next = next.replace(/\{\{\s*start_time\s*\}\}/gi, formatHour(window.deliverySettings.startHour));
    if (closed) return next;
    return istHour() < cutoff ? same : next;
  }

  function cutoffMessage(c, el) {
    var next = el && el.getAttribute ? el.getAttribute('data-next-day') : '';
    if (next) {
      next = next.replace(/\{\{\s*start_time\s*\}\}/gi, formatHour(deliverySchedule(c).start));
      return next;
    }
    return 'Lucknow delivery for this item is closed for today. Please order tomorrow after ' + formatHour(deliverySchedule(c).start) + '.';
  }

  function setCutoffDisabled(el, disabled) {
    if (!el) return;
    if (disabled) {
      if (!el.hasAttribute('data-mlp-cutoff-disabled') && !el.disabled) {
        el.setAttribute('data-mlp-cutoff-disabled', 'true');
        el.disabled = true;
      }
    } else if (el.hasAttribute('data-mlp-cutoff-disabled')) {
      el.removeAttribute('data-mlp-cutoff-disabled');
      el.disabled = false;
    }
  }

  function setText(el, value) {
    if (!el) return;
    if (el.textContent !== value) el.textContent = value;
    el.hidden = !value;
  }

  function shortLabel(label) {
    return String(label || '').split(',').slice(0, 2).join(',').trim();
  }

  function update() {
    var s = getState();
    if (!s) return;
    var design = !!(window.Shopify && window.Shopify.designMode);
    var state = design ? 'ok' : s.state;
    var store = s.c.storeName || 'Aliganj';
    var t, x, b, ct, cb;
    var closed = s.state === 'ok' && isClosedHours(s.c);

    if (state === 'ok') {
      t = closed ? 'Lucknow delivery is closed for this time' : 'Yay, we deliver to you!';
      x = s.loc ? 'Delivering to: ' + shortLabel(s.loc.label) + ' (' + s.dist.toFixed(1) + ' km from our ' + store + ' store)' : '';
      b = 'Change';
      ct = closed ? 'Lucknow delivery is closed for this time' : (s.loc ? 'Delivering to ' + shortLabel(s.loc.label) : 'Delivery available');
      cb = 'Change';
    } else if (state === 'out') {
      t = 'Sorry, we do not deliver here yet';
      x = 'This location is ' + s.dist.toFixed(1) + ' km away. We deliver within ' + s.radius + ' km of our ' + store + ' store.';
      b = 'Change location';
      ct = 'Not deliverable to this location';
      cb = 'Change';
    } else {
      t = 'Check delivery availability';
      x = 'Select your delivery location to see if we deliver to you.';
      b = 'Select location';
      ct = 'Select delivery location';
      cb = 'Select';
    }

    document.querySelectorAll('[data-mlp-delivery]').forEach(function (box) {
      setText(box.querySelector('[data-mlp-d-title]'), t);
      setText(box.querySelector('[data-mlp-d-text]'), x);
      setText(box.querySelector('[data-mlp-d-time]'), state === 'ok' ? timing(box, closed) : '');
      setText(box.querySelector('[data-mlp-d-btn]'), b);
      box.setAttribute('data-cutoff-closed', closed ? 'true' : 'false');
      box.closest('product-info')?.querySelectorAll('.product-form__submit').forEach(function(btn){ setCutoffDisabled(btn, closed); });
      box.closest('product-info')?.querySelectorAll('.shopify-payment-button').forEach(function(btn){ btn.style.pointerEvents = closed ? 'none' : ''; btn.setAttribute('aria-disabled', closed ? 'true' : 'false'); });
      if (box.getAttribute('data-state') !== state) box.setAttribute('data-state', state);
    });

    document.querySelectorAll('[data-mlp-card-loc]').forEach(function (el) {
      setText(el.querySelector('[data-mlp-c-text]'), ct);
      setText(el.querySelector('[data-mlp-c-btn]'), cb);
      var card = el.closest('[data-mlp-local]');
      var cardClosed = state === 'ok' && isClosedHours(s.c);
      if (card) {
        card.setAttribute('data-mlp-cutoff-closed', cardClosed ? 'true' : 'false');
        card.querySelectorAll('[data-cpv2-add-btn], [data-cpv2-qty-plus], .cpv2-card__bulk .quantity__button[name="plus"], .cpv2-card__bulk input[type="number"]').forEach(function(el2){ setCutoffDisabled(el2, cardClosed); });
        var cutoffEl = card.querySelector('[data-mlp-card-cutoff]');
        if (cutoffEl) { setText(cutoffEl, cardClosed ? cutoffMessage(s.c, cutoffEl) : ''); cutoffEl.hidden = !cardClosed; }
      }
      if (el.getAttribute('data-state') !== state) el.setAttribute('data-state', state);
    });

    document.querySelectorAll('[data-mlp-local]').forEach(function (card) {
      if (card.getAttribute('data-mlp-state') !== state) card.setAttribute('data-mlp-state', state);
    });
  }

  function toast(msg) {
    var t = document.getElementById('mlp-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'mlp-toast';
      t.setAttribute('role', 'status');
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.className = 'is-visible';
    clearTimeout(t._h);
    t._h = setTimeout(function () { t.className = ''; }, 3800);
  }

  // Returns details when the click / submit must be stopped, otherwise null.
  function check(node) {
    if (window.Shopify && window.Shopify.designMode) return null;
    if (!node || !node.closest) return null;
    var s = getState();
    var pf = node.closest('product-form');
    var box = pf && pf.parentElement ? pf.parentElement.querySelector('[data-mlp-delivery]') : null;
    var card = node.closest('[data-mlp-local]');
    if (!s) return null;
    if (s.state === 'ok' && isClosedHours(s.c)) return { s: s, box: box, closed: true };
    if (s.state === 'ok') return null;
    if (!box && !card) return null;
    return { s: s, box: box, closed: false };
  }

  function guard(e) {
    var b = check(e.target);
    if (!b) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (b.closed) {
      toast(cutoffMessage(b.s.c));
    } else if (b.s.state === 'none' && window.MahalaxmiLocation) {
      window.MahalaxmiLocation.open();
    } else if (b.box) {
      b.box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else {
      toast('Sorry, this item is delivered only within ' + b.s.radius + ' km of our ' + (b.s.c.storeName || 'Aliganj') + ' store.');
    }
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.product-form__submit, ' + CARD_ADD)) guard(e);
  }, true);

  document.addEventListener('submit', function (e) {
    if (e.target.closest && e.target.closest('product-form')) guard(e);
  }, true);

  // Re-run the check whenever the location picker saves a new location.
  function hook() {
    var p = window.MahalaxmiLocation;
    if (!p || p.__mlpHooked) return;
    p.__mlpHooked = true;
    var orig = p.applyLocation.bind(p);
    p.applyLocation = function (loc, opts) {
      orig(loc, opts);
      update();
    };
  }

  function addStyle() {
    var st = document.createElement('style');
    st.textContent =
      '[data-mlp-local]:not([data-mlp-state=ok]) [data-cpv2-add-btn],' +
      '[data-mlp-local]:not([data-mlp-state=ok]) [data-cpv2-qty-plus]{opacity:.55;cursor:not-allowed}' +
      '#mlp-toast{position:fixed;left:50%;bottom:2.4rem;transform:translate(-50%,2rem);max-width:90vw;padding:1rem 1.6rem;' +
      'background:#8b1e1e;color:#fff;border-radius:8px;font-size:1.4rem;line-height:1.4;opacity:0;pointer-events:none;' +
      'transition:opacity .25s,transform .25s;z-index:10000}' +
      '#mlp-toast.is-visible{opacity:1;transform:translate(-50%,0)}';
    document.head.appendChild(st);
  }

  function scheduleUpdate() {
    clearTimeout(timer);
    timer = setTimeout(update, 60);
  }

  function init() {
    addStyle();
    update();
    hook();
    setTimeout(hook, 400);
    setTimeout(update, 800);
    window.addEventListener('storage', update);
    // Variant changes, Show more (AJAX) and modals add new HTML, so re-apply after DOM updates.
    new MutationObserver(scheduleUpdate).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
